import axios from 'axios'
import _ from 'lodash'
import store from '../store/store'

export default () => {
  
  const apiDomain = _.get(store.state, 'apiDomain', 'https://api.gofundraise.com') 
  const region = _.get(store.state, 'region', 'au')

  return {
    async getTeamPage (id) {
      let params_query = {
        params: {
          region: region,
          pageType: 'T',
          excludepageswithrestrictedcreation: 'true',
          pageid: id
        }
      }
      
      let results = ''
      let res = await axios.get(`${apiDomain}/v1/pages/search`, params_query)
      if (res.data.Pages && res.data.Pages.length > 0 && res.data.Pages[0].Id === id) {
        results = res.data.Pages[0]
      }

      return results
    },

    generateCreatePageUrl() {
      let params = ''
      let eventId = store.state.selected_event.EventCampaignId
      let charityId = store.state.selected_charity.beneficiaryId
      
      if (store.state.pageType !== 'joinTeam') {
        let pageType = store.state.pageType === 'createTeam' ? 't' : 's';
        params = `pagetype=${pageType}&eid=${eventId}&cid=${charityId}`
      } else {
        params = `tid=${store.state.selected_teampage.page.Id}`
      }
      
      if (store.state.referrer && store.state.referrer !== '') {                                               
        params = `${params}&eidtype=${store.state.referrer}`
      }

      return `/pages/create?${params}`
    }
  }

}
